import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'
import PermContactCalendarOutlinedIcon from 'components/material-symbol/icons/PermContactCalendar'
import EnhancedTable from 'components/tables/enhanced-table'
import SectionEmptyState from 'components/section-empty-state'
import { LeadTableItem } from './lead-table-item'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useStyles = makeStyles(theme => ({
  listEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))

const NewLeads = ({
  awaitingResponseLeads,
  contactMethodOptions = [],
  refetch,
  sortByFullName,
  sortByCreatedOn,
  page,
  onPageChange,
  rowsPerPage = 25,
  emptyCaption = 'No leads awaiting response.',
}) => {
  const classes = useStyles()
  const isDesktop = useMediaQuery('(min-width: 1200px)')

  return (
    <EnhancedTable
      rows={awaitingResponseLeads.map(lead => (
        <LeadTableItem
          lead={lead}
          key={lead.id}
          contactMethodOptions={contactMethodOptions}
          refetch={refetch}
          showRespondButton
          showRelativeTime
        />
      ))}
      initialOrderBy="submitted"
      initialOrder="desc"
      columns={[
        {
          id: 'name',
          label: 'Name',
          align: 'left',
          width: isDesktop ? '20%' : '50%',
          mobile: true,
          sortable: true,
          sortComparator: sortByFullName,
        },
        {
          id: 'submitted',
          label: 'Submitted',
          align: 'left',
          width: '20%',
          mobile: false,
          sortable: true,
          sortComparator: sortByCreatedOn,
        },
        {
          id: 'interest',
          label: 'Interest',
          align: 'left',
          width: '20%',
          mobile: false,
          sortable: false,
        },
        {
          id: 'actions',
          label: '',
          align: 'right',
          width: isDesktop ? '10%' : '20%',
          mobile: true,
          sortable: false,
        },
      ]}
      label="Awaiting Response"
      numberOfRows={rowsPerPage}
      variant="list"
      rowHeight="56px"
      page={page}
      onPageChange={onPageChange}
      showHeaderPagination={false}
      showPaginator={false}
      emptyState={() => (
        <Box className={classes.listEmptyStateContent}>
          <SectionEmptyState
            Icon={PermContactCalendarOutlinedIcon}
            title="Leads"
            caption={emptyCaption}
            bordered={false}
          />
        </Box>
      )}
    />
  )
}

export default NewLeads
